import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { ButtonView, View, ViewCollection, FocusCycler } from 'ckeditor5/src/ui';
import imageIcon from './auto-format.svg';

export class SBFormatTablePlugin extends Plugin {

    static get pluginName() {
        return 'SBFormatTable';
    }

    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add( 'sbFormatTable', locale => {
            const view = new ButtonView( locale );
            view.set( {
                label: 'Format Table',
                icon: imageIcon,
                tooltip: true
            });

            // TODO: Figure out why this isn't working
            const selectTableRowCommand = editor.commands.get( 'selectTableRow' );
            view.bind( 'isEnabled' ).to( selectTableRowCommand, 'isEnabled', value => {
                return value;
            } );

            view.on( 'execute', () => {
                const tableUtils = this.editor.plugins.get( 'TableUtils' );
                const model = this.editor.model;
                const referenceCells = tableUtils.getSelectionAffectedTableCells( model.document.selection );
                const table = referenceCells[ 0 ].findAncestor( 'table' );
                const rangesToSelect = [];

                for ( const cell of table.getChild( 0 ).getChildren() ) {
                    rangesToSelect.push( model.createRangeOn( cell ) );
                }

                model.change( writer => {
                    writer.setSelection( rangesToSelect );
                    editor.execute( 'tableCellBackgroundColor', {value: 'hsl(0, 0%, 90%)'} );
                    this.executeSetCellBorder();
                    this.setAllCellBorders();
                });
            });

            return view;
        });
    }

    executeSetCellBorder() {
        const editor = this.editor;
        editor.execute( 'tableCellBorderColor', {value: 'hsl(0, 0%, 0%)'} );
        editor.execute( 'tableCellBorderStyle', {value: 'solid'} );
        editor.execute( 'tableCellBorderWidth', {value: 1} );
        editor.execute( 'tableCellPadding', {value: '5px'} );
    }

    setAllCellBorders() {
        const model = this.editor.model;
        const tableUtils = this.editor.plugins.get( 'TableUtils' );
        const referenceCells = tableUtils.getSelectionAffectedTableCells( model.document.selection );
        const table = referenceCells[ 0 ].findAncestor( 'table' );

        const rangesToSelect = [];
        for ( let rowIndex = 1; rowIndex <= table.childCount; rowIndex++ ) {
            if(table.getChild( rowIndex )) {
                for (const cell of table.getChild(rowIndex).getChildren()) {
                    rangesToSelect.push(model.createRangeOn(cell));
                }
            }
        }

        model.change( writer => {
            writer.setSelection( rangesToSelect );
            this.executeSetCellBorder();
        });
    }
}
